/* eslint-disable @typescript-eslint/no-explicit-any */

import type { AnyAction } from 'redux';
import { ThunkDispatch } from '@reduxjs/toolkit';

import { updatePackageData } from './packageDataSlice';
import {
  resetPackageVars, updatePackageVars, updateSeats,
} from './sessionSlice';

export const handleNewPackageData = async (
  data: AddOrRemovePerformanceResponse,
  dispatch: ThunkDispatch<any, any, AnyAction>,
  shouldUpdatePackageVars = false,
) => {
  const {
    activePromoCode,
    maximumPerformances,
    upsellMessages,
    successMessages,
    minimumPerformances,
    performancesInPackage,
  } = data;

  if (performancesInPackage) dispatch(updatePackageData(performancesInPackage));

  if (performancesInPackage && performancesInPackage.length > 0) {
    if (shouldUpdatePackageVars) {
      // packageLineItemId doesn't exist for single cyo, so we keep it at 0 in that case
      const packageLineNo = performancesInPackage.slice(-1).pop()?.packageLineItemId;

      if (packageLineNo) {
        dispatch(updatePackageVars({
          activePromoCode,
          maximumPerformances,
          minimumPerformances,
          packageLineNo,
          upsellMessages,
          successMessages,
        }));
      } else {
        throw Error('Error: invalid package line number');
      }
    }
  } else if (performancesInPackage && performancesInPackage.length === 0) {
    if (shouldUpdatePackageVars) dispatch(resetPackageVars());
  } else {
    throw Error('Error: no valid performances data returned');
  }
};

export const deriveSeatNumberAndUpdateStore = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  performance: PerformanceInPackage,
) => {
  const { tickets } = performance;
  const seats = tickets.length;

  dispatch(updateSeats(seats));
};
